var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main bg-gray-light min-h-screen"},[(_vm.navbar)?_c('Navbar'):_vm._e(),(_vm.$route.meta.admin)?_c('NavbarAdmin'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }